import Typewriter from "react-typewriter-effect";
import { useTheme } from "styled-components";
import { useState, useEffect } from "react";
import styled from "styled-components";

const TypewriterWrapper = styled.div`
  
    opacity: ${({ showCursor }) => (showCursor ? 1 : 0)};

`;
const HeaderTyping = ({text,fontSize,azul, delay, ultimo,typeSpeed}) => {
    const theme = useTheme();
    const [showCursor, setShowCursor] = useState(false);
    useEffect(() => {
       
        const timeout = setTimeout(() => {setShowCursor(true);}, delay); 

        return () => clearTimeout(timeout);
      }, [delay]);
    return (
        <TypewriterWrapper showCursor={showCursor} >
            <Typewriter
                textStyle={{
                fontSize: {fontSize},
                fontWeight: "bold",
                color: azul ? theme.colors.secondary : theme.colors.white,
                display: "inline-block",
                }}
                startDelay={delay}
                cursorColor="white"
                text={text}
                typeSpeed={typeSpeed}
                deleteSpeed={80}
                delaySpeed={1500}
                loop={true}
                hideCursorAfterText={!ultimo}
            />
        </TypewriterWrapper> 
);
}

export default HeaderTyping;